<template>
    <div class="homeFooter">
          <div class="footerVal">
              <div class="footeritem" @click="goToPageFN('1-1')">{{$t('adviceVal')}}</div>
              <div class="footeritem" @click="goToPageFN('1-2')">{{$t('aboutVal')}}</div>
              <div class="footeritem" @click="goToPageFN('1-3')">{{$t('contactVal')}}</div>
              <div class="footeritem" @click="goToPageFN('1-4')">{{$t('declareVal')}}</div>
              <div class="footeritem" @click="goToPageFN('1-5')" style="border-right:0px">{{$t('privateVal')}}</div>
          </div>
          <div class="footerSec">
              <div class="footeritem2">{{$t('companyVal')}}</div>
              <div class="footeritem2" @click="gotoBeian()" style="border-right:0px">{{$t('recordVal')}}</div>
          </div>
      </div>
</template>
<script>
export default {
  data () {
    return {}
  },
  mounted () {},
  methods: {
    goToPageFN (e) {
      if (e === '1-1') {
        this.$router.push({
          path: `/advice`
        })
      }
      if (e === '1-2') {
        this.$router.push({
          path: `/aboutUs`
        })
      }
      if (e === '1-3') {
        this.$router.push({
          path: `/contactUs`
        })
      }

      if (e === '1-4') {
        this.$router.push({
          path: `/copyRight`
        })
      }
      if (e === '1-5') {
        this.$router.push({
          path: `/invisible`
        })
      }
    },

    gotoBeian(){
      window.open("https://beian.miit.gov.cn","_blank");
    }
  }
}
</script>
<style lang="scss">

</style>
<style>
    .footeritem{
        cursor: pointer;
        text-align:center !important
    }
    .footeritem:hover{
        color: #40A0F0;
    }

    .footeritem2{
        cursor: pointer;
        text-align:center !important;
        width: 180px;
    }
    .footeritem2:hover{
        color: #40A0F0;
    }
</style>
